<div class="maia-prepare-step" data-testid="maia-prepare-panel">

    <div class="step-canvas">
        <div class="step-stage">

            <section class="wizard-card" data-testid="maia-prepare-card">


                <h2 class="card-title">Prepare your SOV</h2>

                <p class="card-description">
                    MAPTYCS matched your file columns automatically. Verify the mapping below.
                </p>

                <div class="review-panel">

                    <div class="mapping-summary" data-testid="maia-prepare-summary">
                        <svg class="mapping-summary-icon" width="15" height="15" viewBox="0 0 24 24"
                             fill="none" aria-hidden="true">
                            <circle cx="12" cy="12" r="9" fill="currentColor"/>
                            <path d="m8.5 12.2 2.3 2.3 4.7-4.7" stroke="#ffffff" stroke-width="1.8"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>{{ mappedCount }} of {{ fieldTotal }} fields mapped successfully</span>
                    </div>

                    <div *ngIf="errorMessage" class="mapping-notice" role="status" data-testid="maia-prepare-error">
                        {{ errorMessage }}
                    </div>
                    <div *ngIf="saving" class="mapping-saving" role="status" data-testid="maia-prepare-saving">
                        Saving…
                    </div>

                    <div class="mapping-table" data-testid="maia-prepare-table">
                        <div class="mapping-grid" [class.mapping-grid-no-action]="!showActionColumn">

                            <span class="mapping-head">SOV Source Field</span>
                            <span class="mapping-head mapping-head-arrow"></span>
                            <span class="mapping-head">MAPTYCS Field</span>
                            <span class="mapping-head">Notes</span>
                            <span *ngIf="showActionColumn" class="mapping-head mapping-head-decision">Action</span>

                            <ng-container *ngFor="let row of visibleRows">
                                <span class="mapping-cell">
                                    <code class="source-field">{{ row.sourceField }}</code>
                                </span>

                                <span class="mapping-cell mapping-cell-arrow" aria-hidden="true">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path d="M4 12h15m0 0-5.5-5.5M19 12l-5.5 5.5" stroke="currentColor"
                                              stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>

                                <span class="mapping-cell">
                                    <input type="text"
                                           class="mapping-input"
                                           [class.mapping-input-empty]="!row.maiaFieldLabel || !row.maiaFieldLabel.trim()"
                                           [class.mapping-input-locked]="row.locked"
                                           [readonly]="row.locked"
                                           [disabled]="saving"
                                           [attr.title]="row.locked ? 'Already a field in this dataset - it cannot be changed' : null"
                                           required
                                           placeholder="Enter MAPTYCS field name"
                                           [ngModel]="row.maiaFieldLabel || ''"
                                           (ngModelChange)="onFieldInput(row, $event)"
                                           (blur)="commitField(row)"
                                           (keydown.enter)="commitField(row)"
                                           [attr.data-testid]="'maia-prepare-field-' + row.sourceField"/>
                                    <span *ngIf="row.maiaFieldId"
                                          class="mapping-field-id"
                                          [attr.data-testid]="'maia-prepare-field-id-' + row.sourceField">{{ row.maiaFieldId }}</span>
                                </span>

                                <span class="mapping-cell mapping-cell-note">{{ row.note }}</span>

                                <span *ngIf="showActionColumn" class="mapping-cell mapping-cell-decision">
                                    <span class="decision-badge"
                                          [class.decision-badge-editing]="row.decision === FieldMappingDecision.EDITING"
                                          [attr.data-testid]="'maia-prepare-decision-' + row.sourceField">
                                        {{ row.decision === FieldMappingDecision.SKIPPED ? 'Skipped'
                                           : row.decision === FieldMappingDecision.EDITING ? 'Editing' : 'Accepted' }}
                                        <svg *ngIf="row.decision !== FieldMappingDecision.EDITING"
                                             width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <path d="m5 12.5 4.5 4.5L19 7" stroke="currentColor" stroke-width="2.4"
                                                  stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>

                                    <button type="button"
                                            class="link-button decision-edit"
                                            [attr.data-testid]="'maia-prepare-edit-' + row.sourceField"
                                            (click)="edit(row)">
                                        Edit
                                    </button>
                                </span>
                            </ng-container>

                        </div>
                    </div>

                    <div class="info-strip info-strip-muted">
                        <svg class="strip-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M12 3.2 19 6v6.2c0 4.2-2.9 7-7 8.6-4.1-1.6-7-4.4-7-8.6V6z"
                                  stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
                        </svg>
                        <span class="strip-text">
                            Mappings are processed in-memory and validated against ISO standard taxonomy.
                        </span>
                    </div>

                </div>

                <div class="card-actions">
                    <button type="button"
                            class="primary-button"
                            data-testid="maia-prepare-continue-button"
                            [disabled]="!canContinue"
                            (click)="acceptAndContinue()">
                        {{ saving ? 'Saving…' : 'Accept and Continue' }}
                    </button>
                </div>

            </section>

        </div>
    </div>
</div>
